import React from "react";
import {MuiRFF} from '../../form';
import Paper from "@mui/material/Paper";
import {makeStyles} from "@mui/styles";
import classnames from "classnames";


const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 16px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        color: theme.vars.palette.background.paper,
        boxShadow: 'none',
    },
}))

/**
 * @type {import('mui-rff').DatePicker}
 * @param props {import('mui-rff').DatePickerProps}
 */
export const DatePickerForm = (props) => {
    const classes = useStyles();

    return (
        <Paper className={classnames(classes.root, 'date-picker-with-paper')}>
            <MuiRFF.DatePicker
                {...props}
                textFieldProps={{
                    ...(props?.textFieldProps ?? {}),
                    variant: 'standard',
                    InputProps: {
                        ...(props?.textFieldProps?.InputProps ?? {}),
                        disableUnderline: true,
                    },
                }}
            />
        </Paper>
    );
}
